import { createCustomSlice } from 'core/utils';

const initialState = {

};

const sharedSlice = createCustomSlice({
    initialState,
    name: 'shared',
    reducers: {},
    saga: [
        'actionThrottle',
        'sendError'
    ]
});

export const sharedActions = sharedSlice.actions;

export default sharedSlice.reducer;
